<template>
  <div class="data-table">
    <a-table
      :loading="loading"
      :columns="columns"
      :data-source="data"
      :row-key="(record, index) => index"
      :pagination="false"
    >
      <div slot="order" slot-scope="text, record, index">
        <span>{{ index + 1 }}</span>
      </div>
      <div slot="submitStatus" slot-scope="text, record">
        {{ record.submitStatus | submitStatusFilter }}
      </div>
      <div slot="action" slot-scope="text, record">
        <a
          v-if="record.submitStatus === 1"
          @click="handleActionClick('summary', record)"
        >
          总结
        </a>
        <a
          v-if="record.submitStatus === 2 || record.submitStatus === 3"
          @click="handleActionClick('check', record)"
        >
          查看
        </a>
      </div>
    </a-table>
    <base-pagination
      :current-page="pagination.page"
      :page-size="pagination.size"
      :total="pagination.total"
      @onChange="handlePaginationChange"
      @onShowSizeChange="handlePaginationChange"
    />
  </div>
</template>

<script>
const columns = [
  {
    title: '序号',
    key: 'order',
    width: 100,
    scopedSlots: { customRender: 'order' }
  },
  {
    title: '活动名称',
    dataIndex: 'activityName',
    key: 'activityName',
    width: 100
  },
  {
    title: '品牌',
    dataIndex: 'principalName',
    key: 'principalName',
    width: 100
  },
  {
    title: '区域',
    dataIndex: 'areaName',
    key: 'areaName',
    width: 100
  },
  {
    title: '经销商名称',
    dataIndex: 'dealerName',
    key: 'dealerName',
    width: 100
  },
  {
    title: '问题总结',
    dataIndex: 'summary',
    key: 'summary',
    width: 100,
  },
  {
    title: '改进措施',
    dataIndex: 'measure',
    key: 'measure',
    width: 100,
  },
  {
    title: '提交状态',
    dataIndex: 'submitStatus',
    key: 'submitStatus',
    width: 100,
    scopedSlots: { customRender: 'submitStatus' }
  },
  {
    title: '操作',
    key: 'action',
    width: 100,
    fixed: 'right',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  name: 'DataTable',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default () {
        return []
      }
    },
    pagination: {
      type: Object,
      default () {
        return {
          current: 1,
          pageSize: 10,
          total: 0
        }
      }
    }
  },
  data () {
    return {
      columns
    }
  },
  filters: {
    submitStatusFilter (val) {
      let text = ''

      switch (val) {
        case 1:
          text = '未提交'
          break
        case 2:
          text = '按时提交'
          break
        case 3:
          text = '延迟提交'
          break
      }

      return text
    }
  },
  methods: {
    // 处理操作点击
    handleActionClick(type, record) {
      this.$emit('action-click', type, { ...record })
    },
    // 处理分页改变
    handlePaginationChange(page, size) {
      this.$emit('pagination-change', page, size)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
